import "../../styles/base.css";
import "../../styles/board.css";
import "../../styles/common.css?ver=1";
import "../../styles/is.css?ver=2";
import { useEffect, useState } from "react";
import $ from "jquery";

function Rslt_outcome() {
  const [activeTab, setActiveTab] = useState("f");
  const handleClick = (ord: any) => {
    setActiveTab(ord);
  };

  return (
    <section className="sec-centent">
      <div id="space" style={{ height: "50px" }}></div>
      <div id="sub" className="mission">
        <div className="missionTitle">시스템개발(System Integration)</div>
        <div className="cont-wr" style={{ padding: "30px 0px" }}>
          <div className="wr">
            <ul className="con-tab-menu ">
              <li>
                <a
                  href="javascript://"
                  onClick={() => handleClick("f")}
                  className={activeTab === "f" ? "active" : ""}
                >
                  <span>현재 ~ 2020년</span>
                </a>
              </li>
              <li>
                <a
                  href="javascript://"
                  onClick={() => handleClick("s")}
                  className={activeTab === "s" ? "active" : ""}
                >
                  <span>2019년 ~ 2010년</span>
                </a>
              </li>
              <li>
                <a
                  href="javascript://"
                  onClick={() => handleClick("t")}
                  className={activeTab === "t" ? "active" : ""}
                >
                  <span>2009년 ~ 2005년</span>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div
        className="boardListArea"
        id="boardListArea"
        style={{ display: activeTab === "f" ? "block" : "none" }}
      >
        <div className="srboardList" style={{ marginTop: "10px" }}>
          <div className="listTable">
            <table className="colTbl" summary="구축실적">
              <colgroup>
                <col width="15%" className="mob-none" />
                <col width="50%" />
                <col width="25%" />
                <col width="10%" className="mob-none" />
              </colgroup>
              <tbody>
                <tr>
                  <td className="mob-none" rowSpan={2}>
                    2025
                  </td>
                  <td className="title">농업경영종합정보시스템 위탁관리</td>
                  <td>농촌진흥청</td>
                  <td className="mob-none"></td>
                </tr>
                <tr>
                  <td className="title">
                    온라인거래소 통합플랫폼 정산시스템 유지보수{" "}
                  </td>
                  <td>한국농수산식품유통공사</td>
                  <td className="mob-none"></td>
                </tr>

                <tr>
                  <td className="mob-none" rowSpan={2}>
                    2024
                  </td>
                  <td className="title">농업경영종합정보시스템 위탁관리</td>
                  <td>농촌진흥청</td>
                  <td className="mob-none"></td>
                </tr>
                <tr>
                  <td className="title">
                    온라인거래소 통합플랫폼 정산시스템 구축{" "}
                  </td>
                  <td>한국농수산식품유통공사</td>
                  <td className="mob-none"></td>
                </tr>
                
                
                <tr>
                  <td className="mob-none" rowSpan={4}>
                    2023
                  </td>
                  <td className="title">농업경영종합정보시스템 위탁관리</td>
                  <td>농촌진흥청</td>
                  <td className="mob-none"></td>
                </tr>
                <tr>
                  <td className="title">
                    온라인거래소 통합플랫폼 B2B시스템 구축{" "}
                  </td>
                  <td>한국농수산식품유통공사</td>
                  <td className="mob-none"></td>
                </tr>
                <tr>
                  <td className="title">
                   CJ 프레시웨이 FS메뉴관리시스템 안정화 용역{" "}
                  </td>
                  <td>CJ프레시웨이</td>
                  <td className="mob-none"></td>
                </tr>

                <tr>
                  <td className="title">
                    {" "}
                    CJ 프레시웨이 FS메뉴관리시스템 구축 
                  </td>
                  <td>CJ프레시웨이</td>
                  <td className="mob-none"></td>
                </tr>

                <tr>
                  <td className="mob-none">2022</td>
                  <td className="title">사이버거래시스템 위탁운영 용역</td>
                  <td>한국농수산식품 유통공사</td>
                  <td className="mob-none"></td>
                </tr>

                <tr>
                  <td className="mob-none" rowSpan={3}>
                    2021
                  </td>
                  <td className="title">사이버거래시스템 위탁운영 용역</td>
                  <td>농수산식품거래소</td>
                  <td className="mob-none"></td>
                </tr>
                <tr>
                  <td className="title">공공급식 통합시스템구축(입찰계약관리)</td>
                  <td>농수산식품거래소</td>
                  <td className="mob-none"></td>
                </tr>

                <tr>
                  <td className="title">2021 농업경영종합정보시스템 위탁관리 용역</td>
                  <td>농촌진흥청</td>
                  <td className="mob-none"></td>
                </tr>

                <tr>
                  <td className="mob-none" rowSpan={2}>
                    2020
                  </td>
                  <td className="title">사이버거래시스템 위탁운영 용역</td>
                  <td>농식품거래소</td>
                  <td className="mob-none"></td>
                </tr>
                <tr>
                  <td className="title">공공급식 식재료 표준체계 구축</td>
                  <td>농식품거래소</td>
                  <td className="mob-none"></td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div
        className="boardListArea"
        id="boardListArea2"
        style={{ display: activeTab === "s" ? "block" : "none" }}
      >
        <div className="srboardList" style={{ marginTop: "10px" }}>
          <div className="listTable">
            <table className="colTbl" summary="구축실적">
              <colgroup>
                <col width="15%" className="mob-none" />
                <col width="50%" />
                <col width="25%" />
                <col width="10%" className="mob-none" />
              </colgroup>

              <tbody>
                <tr>
                  <td className="mob-none">2019</td>
                  <td className="title">
                    학교급식지원센터 시스템 고도화 구축 용역
                  </td>
                  <td>농수산물사이버거래소</td>
                  <td className="mob-none"></td>
                </tr>

                <tr>
                  <td className="mob-none">2018</td>
                  <td className="title">
                    정가수의매매 예약정보 제공 시스템 유지관리 용역
                  </td>
                  <td>한국농수산식품유통공사</td>
                  <td className="mob-none"></td>
                </tr>

                <tr>
                  <td className="mob-none">2017</td>
                  <td className="title">친환경인증정보시스템 관리 운영 사업</td>
                  <td>한국농수산식품유통공사</td>
                  <td className="mob-none"></td>
                </tr>
                <tr>
                  <td className="mob-none" rowSpan={3}>
                    2016
                  </td>
                  <td className="title">
                    정가수의매매 예약거래 정보 제공시스템 개편 용역
                  </td>
                  <td>농림수산식품교육문화정보원</td>
                  <td className="mob-none"></td>
                </tr>
                <tr>
                  <td className="title">
                    학교급식지원센터 통합관리 시스템 2차구축
                  </td>
                  <td>농수산물사이버거래소</td>
                  <td className="mob-none"></td>
                </tr>
                <tr>
                  <td className="title">
                    정가수의매매 예약거래 정보 제공시스템 개편 용역
                  </td>
                  <td>한국농수산식품유통공사</td>
                  <td className="mob-none"></td>
                </tr>

                <tr>
                  <td className="mob-none" rowSpan={2}>
                    2015
                  </td>
                  <td className="title">
                    2015년 사이버거래시스템 응용SW 위탁운영 용역
                  </td>
                  <td>농수산물사이버거래소</td>
                  <td className="mob-none"></td>
                </tr>
                <tr>
                  <td className="title">
                    2015년 농수축산 경락 및 조사가 격정보 개방체계 구축사업
                  </td>
                  <td>한국정보화진흥원</td>
                  <td className="mob-none"></td>
                </tr>

                <tr>
                  <td className="mob-none" rowSpan={5}>
                    2014
                  </td>
                  <td className="title">정가수의매매 예약거래시스템 구축 용역</td>
                  <td>한국농수산식품유통공사</td>
                  <td className="mob-none"></td>
                </tr>
                <tr>
                  <td className="title">축산물이력제 전산시스템 유지보수</td>
                  <td>축산물품질평가원</td>
                  <td className="mob-none"></td>
                </tr>
                <tr>
                  <td className="title">FTA 피해보전 정보 제공시스템 구축</td>
                  <td>축산물품질평가원</td>
                  <td className="mob-none"></td>
                </tr>
                <tr>
                  <td className="title">eaT 학교급식지원센터 통합 ICT시스템 구축</td>
                  <td>농수산물사이버거래소</td>
                  <td className="mob-none"></td>
                </tr>
                <tr>
                  <td className="title">축산물이력제 전산시스템 유지보수</td>
                  <td>축산물품질평가원</td>
                  <td className="mob-none"></td>
                </tr>

                <tr>
                  <td className="mob-none" rowSpan={3}>
                    2013
                  </td>
                  <td className="title">2013년 사이버거래시스템 구축 용역</td>
                  <td>농수산물사이버거래소</td>
                  <td className="mob-none"></td>
                </tr>
                <tr>
                  <td className="title">사이버거래소 응용프로그램 위탁운영 용역</td>
                  <td>한국농수산식품유통공사</td>
                  <td className="mob-none"></td>
                </tr>
                <tr>
                  <td className="title">축산물이력제 전산시스템 유지보수 용역</td>
                  <td>축산물품질평가원</td>
                  <td className="mob-none"></td>
                </tr>

                <tr>
                  <td className="mob-none" rowSpan={3}>
                    2012
                  </td>
                  <td className="title">
                    한우종합과 쇠고기이력제 데이타 연동시스템 개발
                  </td>
                  <td>농업협동조합중앙회</td>
                  <td className="mob-none"></td>
                </tr>
                <tr>
                  <td className="title">
                    사이버거래소 응용프로그램 고도화 및 유지보수용역{" "}
                  </td>
                  <td>한국농수산식품유통공사</td>
                  <td className="mob-none"></td>
                </tr>
                <tr>
                  <td className="title">
                    쇠고기이력제 전산시스템 유지보수 업체선정 의뢰
                  </td>
                  <td>축산물품질평가원</td>
                  <td className="mob-none"></td>
                </tr>

                <tr>
                  <td className="mob-none">2011</td>
                  <td className="title">
                    단체급식 전자조달시스템 구축 및 응용프로그램 유지보수 용역
                  </td>
                  <td>한국농수산식품유통공사</td>
                  <td className="mob-none"></td>
                </tr>

                <tr>
                  <td className="mob-none" rowSpan={4}>
                    2010
                  </td>
                  <td className="title">2010 농수산물사이버거래시스템 고도화 구축용역</td>
                  <td>농수산물사이버거래소</td>
                  <td className="mob-none"></td>
                </tr>
                <tr>
                  <td className="title">
                    정산시스템 성능개선 사업
                  </td>
                  <td>서울시농수산물공사</td>
                  <td className="mob-none"></td>
                </tr>
                <tr>
                  <td className="title">쇠고기이력제실험실 정보관리시스템 구축</td>
                  <td>축산물품질평가원</td>
                  <td className="mob-none"></td>
                </tr>
                <tr>
                  <td className="title">
                    소모품관리 통합시스템 구축
                  </td>
                  <td>농림수산식품 부 국립농산물 품질관리원</td>
                  <td className="mob-none"></td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <div
        className="boardListArea"
        id="boardListArea3"
        style={{ display: activeTab === "t" ? "block" : "none" }}
      >
        <div className="srboardList" style={{ marginTop: "10px" }}>
          <div className="listTable">
            <table className="colTbl" summary="구축실적">
              <colgroup>
                <col width="15%" className="mob-none" />
                <col width="50%" />
                <col width="25%" />
                <col width="10%" className="mob-none" />
              </colgroup>
              <tbody>
                <tr>
                  <td className="mob-none" rowSpan={3}>
                    2009
                  </td>
                  <td className="title">
                    농림수산식품기술기획평가원 홈페이지구축
                  </td>
                  <td>농림수산식품 기술기획평가원</td>
                  <td className="mob-none"></td>
                </tr>
                <tr>
                  <td className="title">농식품 품질검정 통합 시스템 구축</td>
                  <td>농림수산식품 부 국립농산물 품질관리원</td>
                  <td className="mob-none"></td>
                </tr>
                <tr>
                  <td className="title">농수산물사이버거래시스템 구축</td>
                  <td>농수산물유통공사</td>
                  <td className="mob-none"></td>
                </tr>

                <tr>
                  <td className="mob-none">2008</td>
                  <td className="title">농산물정보시스템고도화</td>
                  <td>농림수산식품 부 국립농산물 품질관리원</td>
                  <td className="mob-none"></td>
                </tr>
                <tr>
                  <td className="mob-none" rowSpan={5}>
                    2007
                  </td>
                  <td className="title">농업통계시스템(친환경인증 정보시스템)개발</td>
                  <td>(주)이지팜</td>
                  <td className="mob-none"></td>
                </tr>
                <tr>
                  <td className="title">농업통계시스템 교체 및 운영 환경 고도화</td>
                  <td>SK C&C(주)</td>
                  <td className="mob-none"></td>
                </tr>
                <tr>
                  <td className="title">농림사업통합시스템 SM 유지 보수</td>
                  <td>(주)LG-CNS</td>
                  <td className="mob-none"></td>
                </tr>
                <tr>
                  <td className="title">
                    농림사업통합정보시스템구축
                  </td>
                  <td>농림부</td>
                  <td className="mob-none"></td>
                </tr>
                <tr>
                  <td className="title">
                   육류이력추적시스템 통합구축사업
                  </td>
                  <td>축산물등급판정소</td>
                  <td className="mob-none"></td>
                </tr>

                <tr>
                  <td className="mob-none" rowSpan={4}>
                    2006
                  </td>
                  <td className="title">상장예외품목정산시스템</td>
                  <td>서울시농수산물공사</td>
                  <td className="mob-none"></td>
                </tr>
                <tr>
                  <td className="title">
                    농업생산기반정비사업총사업 비관리시스템개발
                  </td>
                  <td>한국농촌공사 농어촌연구원</td>
                  <td className="mob-none"></td>
                </tr>
                <tr>
                  <td className="title">소프트및하드웨어공학용역</td>
                  <td>농림부</td>
                  <td className="mob-none"></td>
                </tr>
                <tr>
                  <td className="title">농림사업통합정보시스템</td>
                  <td>(주)LG-CNS</td>
                  <td className="mob-none"></td>
                </tr>
                <tr>
                  <td className="mob-none" rowSpan={5}>
                    2005
                  </td>
                  <td className="title">농림사업통합정보시스템 </td>
                  <td>(주)LG-CNS</td>
                  <td className="mob-none"></td>
                </tr>
                <tr>
                  <td className="title">농림사업 통합정보시스템 기초 DB구축사업</td>
                  <td>농림부</td>
                  <td className="mob-none"></td>
                </tr>
                <tr>
                  <td className="title">
                    농림사업통합정보시스템 
                  </td>
                  <td>농림부</td>
                  <td className="mob-none"></td>
                </tr>
                <tr>
                  <td className="title">전국공영도매시장 유지보수 외</td>
                  <td>전국공영도매시장</td>
                  <td className="mob-none"></td>
                </tr>
                <tr>
                  <td className="title">농수산물도매시장유통정보시스템</td>
                  <td>구리농수산물도매시장</td>
                  <td className="mob-none"></td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <div id="sub" className="mission" style={{ display: activeTab === "f" ? "block" : "none" }}>
        <div className="missionTitle">보안컨설팅</div>
        <div className="cont-wr" style={{ padding: "30px 0px" }}>
          <div className="wr">
            <ul className="con-tab-menu ">
              <li>
                <a className="active">
                  <span>현재 ~ 2020년</span>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="boardListArea" id="boardListArea4" style={{ display: activeTab === "f" ? "block" : "none" }}>
        <div className="srboardList" style={{ marginTop: "10px" }}>
          <div className="listTable">
            <table className="colTbl" summary="구축실적">
              <colgroup>
                <col width="15%" className="mob-none" />
                <col width="50%" />
                <col width="25%" />
                <col width="10%" className="mob-none" />
              </colgroup>

              <tbody>
                <tr>
                  <td className="mob-none" rowSpan={2}>
                    2025
                  </td>
                  <td className="title">
                   서브원 ISMS 사후 인증 심사 기술부문 컨설
                  </td>
                  <td>서브원</td>
                  <td className="mob-none"></td>
                </tr>
                
                <tr>
                  <td className="title">
                    AT센터 웹 모의해킹
                  </td>
                  <td>한국농수산식품유통공사</td>
                  <td className="mob-none"></td>
                </tr>

                <tr>
                  <td className="mob-none" rowSpan={7}>
                    2024
                  </td>
                  <td className="title">
                   국방 인터넷 급여포털 웹 모바일 취약점 진단
                  </td>
                  <td>(주)파수</td>
                  <td className="mob-none"></td>
                </tr>
                
                <tr>
                  <td className="title">
                    서브원 웹 모의해킹
                  </td>
                  <td>삼정회계법인</td>
                  <td className="mob-none"></td>
                </tr>
                <tr>
                  <td className="title">
                    KB저축은행 인증수단 웹 모의해킹
                  </td>
                  <td>(주)파수</td>
                  <td className="mob-none"></td>
                </tr>
               
                <tr>
                  <td className="title">
                    CJ ENM 커머스 부문 ISMS인증 취약점 분석 평가 컨설팅
                  </td>
                  <td>삼정회계법인</td>
                  <td className="mob-none"></td>
                </tr>
                <tr>
                  <td className="title">KT 마이데이터 전자금융기반시설 취약점 분석 평가 컨설팅</td>
                  <td>(주)파수</td>
                  <td className="mob-none"></td>
                </tr>
               
                <tr>
                  <td className="title">롯데면세 연간 정보보호 전문가 자문 용역</td>
                  <td>삼정회계법인</td>
                  <td className="mob-none"></td>
                </tr>
                <tr>
                  <td className="title">서브원 ISMS 사후 인증 심사 기술부문 컨설팅</td>
                  <td>삼정회계법인</td>
                  <td className="mob-none"></td>
                </tr>
                
                <tr>
                  <td className="mob-none" rowSpan={8}>
                    2023
                  </td>
                  <td className="title">
                   CJ ENM 커머스 부문 ISMS인증 취약점 취약점 분석 평가 컨설팅
                  </td>
                  <td>삼정회계법인</td>
                  <td className="mob-none"></td>
                </tr>
                
                <tr>
                  <td className="title">
                    CJ ENM 커머스부문 정보시스템 취약점 진단
                  </td>
                  <td>씨제이올리브네트웍스</td>
                  <td className="mob-none"></td>
                </tr>
                <tr>
                  <td className="title">
                    딜리셔스 ISMS 인증 기술적 취약점 진단 컨설팅
                  </td>
                  <td>(주)딜리셔스</td>
                  <td className="mob-none"></td>
                </tr>
               
                <tr>
                  <td className="title">
                    롯데면세 연간 정보보호 전문가 자문 용역
                  </td>
                  <td>삼정회계법인</td>
                  <td className="mob-none"></td>
                </tr>
                <tr>
                  <td className="title">나이스정보통신 모바일 진단 용역</td>
                  <td>(주)파수</td>
                  <td className="mob-none"></td>
                </tr>
               
                <tr>
                  <td className="title">알라딘 모바일 모의해킹 용역</td>
                  <td>(주)파수</td>
                  <td className="mob-none"></td>
                </tr>
                <tr>
                  <td className="title">서브원 소스코드 진단 용역</td>
                  <td>서브원</td>
                  <td className="mob-none"></td>
                </tr>
                <tr>
                  <td className="title">서브원 ISMS인증 기술 컨설팅</td>
                  <td>삼정회계법인</td>
                  <td className="mob-none"></td>
                </tr>

                <tr>
                  <td className="mob-none" rowSpan={3}>
                    2022
                  </td>
                  <td className="title">
                   CJ ENM 커머스 부문 ISMS인증 취약점 취약점 분석 평가 컨설팅
                  </td>
                  <td>삼정회계법인</td>
                  <td className="mob-none"></td>
                </tr>
               
                
                <tr>
                  <td className="title">
                   KDB 생명 영업지원 시스템 모의해킹 컨설팅
                  </td>
                  <td>(주)파수</td>
                  <td className="mob-none"></td>
                </tr>
                
                <tr>
                  <td className="title">
                    세메스 보안개선을 위한 보안 DX 컨설팅
                  </td>
                  <td>(주)파수</td>
                  <td className="mob-none"></td>
                </tr>
                               
                <tr>
                  <td className="mob-none" rowSpan={10}>
                    2021
                  </td>
                  <td className="title">미래엔서해에너지 웹 모의해킹</td>
                  <td>(주)파수</td>
                  <td className="mob-none"></td>
                </tr>
                <tr>
                  <td className="title">
                    네오다임 아마존셀러 홈페이지 침투테스트
                  </td>
                  <td>(주)파수</td>
                  <td className="mob-none"></td>
                </tr>
                <tr>
                  <td className="title">제주개발공사 ISMS 인증 심사 컨설팅</td>
                  <td>(주)파수</td>
                  <td className="mob-none"></td>
                </tr>
                <tr>
                  <td className="title">
                   한국수력원자력 ISMS-P 인증, 마스터플랜 사업
                  </td>
                  <td>(주)파수</td>
                  <td className="mob-none"></td>
                </tr>
                
                <tr>
                  <td className="title">
                    한국고용정보원 HRD-Net 시스템 취약점 점검
                  </td>
                  <td>(주)파수</td>
                  <td className="mob-none"></td>
                </tr>
                <tr>
                  <td className="title">타라유통 보안 네크워크 컨설팅</td>
                  <td>(주)파수</td>
                  <td className="mob-none"></td>
                </tr>
               
                <tr>
                  <td className="title">나이스정보통신 컨설팅</td>
                  <td>(주)파수</td>
                  <td className="mob-none"></td>
                </tr>
                <tr>
                  <td className="title">KT 모바일 진단 용역</td>
                  <td>(주)파수</td>
                  <td className="mob-none"></td>
                </tr>
                <tr>
                  <td className="title">시티랩스 컨설팅 용역</td>
                  <td>(주)파수</td>
                  <td className="mob-none"></td>
                </tr>
                <tr>
                  <td className="title">카이스트 컨설팅 용역</td>
                  <td>(주)파수</td>
                  <td className="mob-none"></td>
                </tr>

                <tr>
                  <td className="mob-none" rowSpan={5}>
                    2020
                  </td>
                  <td className="title">
                    제주개발공사 모바일 서비스 및 무선취약점 점검
                  </td>
                  <td>(주)파수</td>
                  <td className="mob-none"></td>
                </tr>
                <tr>
                  <td className="title">
                    한국고용정보원 HRD-NET 시스템 취약점 점검
                  </td>
                  <td>(주)파수</td>
                  <td className="mob-none"></td>
                </tr>
                <tr>
                  <td className="title">Coredax ISMS-P 인증 컨설팅</td>
                  <td>(주)Coredax</td>
                  <td className="mob-none"></td>
                </tr>                              
                <tr>
                  <td className="title">NICE 그룹 2020년 취약점 분석 평가</td>
                  <td>(주)파수</td>
                  <td className="mob-none"></td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Rslt_outcome;
